import axios from "axios";

export default {
    list(api){
        return api.send.get('projects');
    },

    explorer(api){
        return api.send.get('projects/explorer');
    },

    search(api, query){
        return api.send.get('projects/search?q=' + encodeURIComponent(query));
    },

    listWithFolders(api){
        return api.send.get('projectsWithFolders');
    },

    deleteFolder(api, folder_id){
        return api.send.delete('folders/'+folder_id);
    },

    updateFolderName(api, folder_id, folderName){
        return api.send.put('folders/'+folder_id,{name:  folderName});
    },

    createFolder(api, folderName, parentFolderId){
        return api.send.post('folders',{name:  folderName, parent: parentFolderId});
    },

    view(api, project_id){
        return api.send.get('projects/'+project_id);
    },

    deleteProject(api, project_id){
        return api.send.delete('projects/'+project_id);
    },

    updateProjectName(api, project_id, projectName){
        return api.send.put('projects/'+project_id,{name:  projectName});
    },
    updateProjectPublicAccess(api, project_id, allowAccess, passwordField, accessComment){
        return api.send.put('projects/'+project_id,{public:  allowAccess, password_field: passwordField, access_comment: accessComment});
    },

    replaceProject(api, project_id, folder_id){
        return api.send.post(`projects/${project_id}/replace`,{folder_id: folder_id});
    },

    copyProject(api, project_id){
        return api.send.post(`projects/${project_id}/copy`);
    },

    createProject(api, projectName, folder_id){
        return api.send.post('projects',{name:  projectName, folder_id: folder_id});
    },

    getData(api, project_id, params = {}){
      const query = new URLSearchParams();
      if (params.page) query.set('page', params.page);
      if (params.per_page) query.set('per_page', params.per_page);
      if (params.search) query.set('search', params.search);
      const qs = query.toString();
      return api.send.get(`projects/${project_id}/data${qs ? '?' + qs : ''}`);
    },
    setDataSource(api, project_id, source, confirmRowCount = null){
        const payload = { data_source: source };
        if (confirmRowCount !== null) {
            payload.confirm_row_count = confirmRowCount;
        }
        return api.send.put(`projects/${project_id}/data-source`, payload);
    },

    addDataRow(api, project_id, data){
        return api.send.post(`projects/${project_id}/data/rows`, { data });
    },
    updateDataRow(api, project_id, row, data){
        return api.send.put(`projects/${project_id}/data/rows/${row}`, { data });
    },
    deleteDataRow(api, project_id, row){
        return api.send.delete(`projects/${project_id}/data/rows/${row}`);
    },

    createDataKeys(api, project_id, fields, confirmRowCount = null){
        const payload = { fields };
        if (confirmRowCount !== null) {
            payload.confirm_row_count = confirmRowCount;
        }
        return api.send.post(`projects/${project_id}/data/keys`, payload);
    },
    async downloadDataTemplate(api, project_id){
        const response = await axios.get(api.send.urlWithPrefix(`projects/${project_id}/data/template-csv`), {
            responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'template.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    },

    fetchTestDepoFields(api, project_id, testId, testdepoHost = null, apiKey = null){
        const payload = { test_id: testId };
        if (testdepoHost) payload.testdepo_host = testdepoHost;
        if (apiKey) payload.api_key = apiKey;
        return api.send.post(`projects/${project_id}/data/fetch-testdepo-fields`, payload);
    },

    uploadData(api, project_id, files, confirmRowCount = null){
        var formData = new FormData();
        formData.append("datafile", files[0]);
        if (confirmRowCount !== null) {
            formData.append("confirm_row_count", confirmRowCount);
        }
        return api.send.post(`projects/${project_id}/load`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    downloadFileForRowNumber(api, project_id, row_number){
        window.open(api.send.fullPath(`projects/${project_id}/download/${row_number}`));
    },
    downloadAllFiles(api, project_id, filenameKey){
        window.open(api.send.fullPath(`projects/${project_id}/download?filenameKey=${filenameKey}`));
    },
    getTemplate(api, project_id){
        return api.send.get(`projects/${project_id}/template`);
    },
    uploadTemplateImage(api, project_id, files){
        var formData = new FormData();
        formData.append("file", files[0]);
        return api.send.post(`projects/${project_id}/template/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    processBackground(api, project_id, data){
        return api.send.post(`projects/${project_id}/template/process-background`, data);
    },
    copyTemplateImageFromLibrary(api, project_id, bg_id){
        return api.send.post(`projects/${project_id}/template/copy_from_library`, {bg_id});
    },
    createProjectTemplate(api, project_id, data){
        return api.send.post(`projects/${project_id}/template`,data);
    },

    updateProjectTemplate(api, project_id, data){
        return api.send.put(`projects/${project_id}/template`,data);
    },

    availableFonts(api){
        return api.send.get('fonts');
    },
    listBgTemplates(api){
        return api.send.get('bg_templates');
    },
    loadAccessSheet(api, project_id){
        window.open(api.send.fullPath(`projects/${project_id}/access_sheet`));
    }

}
